export const common = {
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.edit': 'Edit',
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.cancel': 'Cancel',
  'common.clear': 'Clear',
  'common.showFilters': 'Show Filters',
  'common.hideFilters': 'Hide Filters',
  'common.selectFarm': 'Select Farm',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.apply': 'Apply',
  'common.remove': 'Remove',
  'common.upload': 'Upload',
  'common.select': 'Select',
  'common.add': 'Add',
  'common.delete': 'Delete',
  'common.continue': 'Continue',
  'common.goBack': 'Go Back',
  'common.expired': 'Expired',
  'common.pending': 'Pending',
  'common.completed': 'Completed',
  'common.draft': 'Draft',
  'common.share': 'Share',
  'common.copy': 'Copy',
  'common.submit': 'Submit',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.review': 'Review',
  'common.success': 'Success',
  'common.error': 'Error',
  'common.warning': 'Warning',
  'common.info': 'Info',
  'common.applied': 'Applied',
  'common.saved': 'Saved',
  'common.send': 'Send',
  'common.landRegistryCertificate': 'Land Registry Certificate',
  'common.irrigationForm': 'Irrigation Form',
  'common.uploadFromVault': 'Upload from Vault',
  'common.demoDisclaimer': 'This is a demonstration of AgriTool Advisor. Not for actual subsidy applications.',
  'common.lastUpdated': 'Last Updated',
  'common.openClientProfile': 'Open Client Profile',
  'common.applyNow': 'Apply Now',
  'common.newSubsidyAvailable': 'New Subsidy Available',
  'common.documentsRequired': 'Documents Required',
  'common.inReview': 'In Review',
  'common.readyToSubmit': 'Ready to Submit',
  'common.deadlineApproaching': 'Deadline Approaching',
  'common.demoLabel': 'Demo',
  'common.dashboard': 'Dashboard',
  'common.plan': 'Plan',
  'common.consultantPro': 'Consultant Pro',
  'common.free': 'Free',
  'common.coopEnterprise': 'Coop Enterprise',
  'common.documents': 'Documents',
  'common.skipToEUPortal': 'Skip to EU Portal',
  'common.addNewClientFarm': 'Add New Client Farm',
  'common.searchFarms': 'Search farms...',
  'common.name': 'Name',
  'common.region': 'Region',
  'common.status': 'Status',
  'common.size': 'Size',
  'common.activities': 'Activities',
  'common.software': 'Software',
  'common.addNewSubsidy': 'Add New Subsidy',
  'common.noSubsidiesFound': 'No Subsidies Found',
  'common.noSubsidiesFoundDesc': 'No subsidies match the current criteria. Try adjusting your filters.',
  'common.loading': 'Loading',
  'common.close': 'Close',
  'common.continueToEUPortal': 'Continue to EU Portal',
  'common.generateForm': 'Generate Form',
  'common.uploadNow': 'Upload Now',
  'common.viewDetails': 'View Details',
  'common.profile': 'Profile',
  'common.subsidies': 'Subsidies',
  'common.applications': 'Applications',
  'common.getStarted': 'Get Started',
  'common.returnHome': 'Return to Homepage',
  'common.backToDashboard': 'Back to Dashboard',
  'common.explainThis': 'Explain This',
  'common.attach': 'Attach',
  'common.useToPrefillProfile': 'Use to Prefill Profile',
  'common.prefillNow': 'Yes, Prefill Now',
  'common.noThanks': 'No, Thanks',
  'common.dontAskAgain': 'Don\'t Ask Again',
  'common.usePrefillPrompt': 'Would you like to use the information from this document to populate your farm profile?',
  'common.extractionCompleted': 'Document analysis completed',
  'common.extractionAvailable': 'Smart prefill available',
  'common.confidence': 'Confidence',
  'common.prefillApplied': 'Form prefilled with extracted data',
  'common.extractionProcessing': 'Processing document...',
  'common.extractionFailed': 'Document analysis failed',
  'common.extracted': 'Extracted',
  'common.readyToExtract': 'Ready to Extract',
  'common.documentsUploaded': 'Documents Uploaded Successfully',
  'common.extractAndPrefill': 'Extract & Prefill',
  'common.reExtract': 'Re-extract',
  'common.extracting': 'Extracting...',
  'common.extractionSuccess': 'Successfully extracted data from {fileName}',
  'common.extractionError': 'Failed to extract data from document',
  'common.login': 'Login',
  'common.signUp': 'Sign Up',
  'common.startFreeTrial': 'Get Started',
  'common.administrator': 'Administrator',
  'common.businessUser': 'Business User',
  'common.consultant': 'Consultant',
  'common.enterprise': 'Enterprise',
  'common.adminOnly': 'Admin Only',
  'common.devTools': 'Dev Tools', 
  'common.requires': 'Requires',
  'common.role': 'role',
  'common.comingSoon': 'Coming Soon',
  'common.newProfile': 'New Profile',
  'common.yourProfiles': 'Your Profiles',
  'common.yourSuspendedProfiles': 'Your Suspended Profiles',
  'common.findOpportunities': 'Find Opportunities',
  'common.allTypes': 'All Types',
  'common.individual': 'Individual',
  'common.business': 'Business',
  'common.nonprofit': 'Non-Profit',
  'common.municipality': 'Municipality',
  'common.profileCompletion': 'Profile Completion',
  'common.updated': 'Updated',
  'common.availableSubsidies': 'Available Subsidies',
  'common.urgent': 'Urgent',
  'common.viewProfile': 'View Profile',
  'common.completeProfile': 'Complete Profile',
  'common.createNewProfile': 'Create New Profile',
  'common.nextSteps': 'Next Steps',
  'common.highPriority': 'High Priority',
  'common.new': 'New',
  'common.open': 'Open',
  // Legacy migration keys
  'common.tryAgain': 'Try Again',
  'common.backToSearch': 'Back to Search',
  'common.favorite': 'Favorite',
  'common.contactSupport': 'Contact Support',
  'common.pricing': 'Pricing',
  'common.moreInfo': 'More Information',
  'common.features': 'Features',
  'common.menu': 'Menu',
  // AI Assistant page
  'common.aiAssistantTitle': 'AI Assistant',
  'common.aiAssistantDescription': 'Ask questions about subsidies, eligibility, and application processes. Our AI assistant is here to help you.',
  'common.instantAnswers': 'Instant Answers',
  'common.instantAnswersDesc': 'Get quick answers to your subsidy questions',
  'common.personalized': 'Personalized',
  'common.personalizedDesc': 'Advice tailored to your situation and needs',
  'common.available247': '24/7 Available',
  'common.available247Desc': 'Assistance available anytime, day or night',

  // Chat component messages
  'common.chatTitle': 'Subsidy Assistant',
  'common.chatInitialMessage': 'Hello! I can help you understand subsidy requirements and application processes. What would you like to know?',
  'common.chatPlaceholderResponse': 'This is a placeholder response. In a real implementation, this would connect to an AI service to provide detailed subsidy guidance.',
  'common.chatInputPlaceholder': 'Ask about subsidies...',

  // Conversation history
  'common.conversationHistory': 'Conversation History',
  'common.hideHistory': 'Hide History',
  'common.showRecent': 'Recent',
  'common.showArchived': 'Archived',
  'common.noConversations': 'No conversations yet',
  'common.noArchivedConversations': 'No archived conversations',
  'common.messages': 'messages',
  'common.archive': 'Archive',
  'common.unarchive': 'Unarchive',
  'common.confirmDelete': 'Are you sure you want to permanently delete this item?',
  'common.newConversation': 'New Conversation',
  'common.saveConversation': 'Save Conversation',
  'common.conversationSaved': 'Conversation Saved',
  'common.conversationSavedSuccessfully': 'Your conversation has been saved successfully',
  'common.noMessagesToSave': 'No messages to save',
  'common.startConversationFirst': 'Start a conversation before saving it',
  'common.failedToSaveConversation': 'Failed to save conversation',
  'common.conversationArchivedAndNewStarted': 'Previous conversation archived. A new conversation has started.',
  'common.failedToArchiveConversation': 'Failed to archive conversation',

  // Navigation & Sidebar
  'common.favorites': 'Favorites',
  'common.categories': 'Categories',
  'common.help': 'Help',
  'common.admin': 'Admin',
  'common.needHelp': 'Support',

  // Actions
  'common.confirm': 'Confirm',
  'common.view': 'View',
  'common.download': 'Download',
  'common.modify': 'Modify',

  // Status
  'common.closed': 'Closed',

  // Colors
  'common.purple': 'Purple',
  'common.blue': 'Blue',
  'common.green': 'Green',
  'common.amber': 'Amber',
  'common.gray': 'Gray',
  'common.red': 'Red',
  'common.pink': 'Pink',
  'common.teal': 'Teal',

  // Placeholders
  'common.searchProfile': 'Search profile...',
  'common.searchArchivedClient': 'Search archived client...',
  'common.searchByCodeOrActivity': 'Search by NAF code or activity (e.g., consulting, commerce, manufacturing)...',
  'common.searchByTitleOrDescription': 'Search by title, description or agency...',
  'common.searchByNameOrNumber': 'Search by name or number (e.g., commerce, 47, restaurant...)',
  'common.searchTickets': 'Search tickets...',
  'common.searchErrors': 'Search errors by message or type...',
  'common.addDocument': 'Add a document...',
  'common.addNotes': 'Add notes...',
  'common.additionalInfo': 'Additional information about this document...',
  'common.addReviewNotes': 'Add your review notes...',
  'common.addComment': 'Add a comment...',

  // Aria labels
  'common.closeHelp': 'Close help',
  'common.openHelp': 'Open help',
  'common.closeAlerts': 'Close alerts',
  'common.viewDocument': 'View {name} document',
  'common.viewDetailsFor': 'View details for {name}',
  'common.addNewFarm': 'Add New Farm',
  'common.searchYourFarms': 'Search your farms',

  // AddFarm Modal
  'addFarm.createComprehensiveProfile': 'Create a comprehensive business profile with all required information',
  'addFarm.fillCompleteFarmProfile': 'Fill out the complete business profile form to add a new client to your portfolio',
  'addFarm.startProfileCreation': 'Start Profile Creation',

  // Sorting & Filtering
  'common.sortRecent': 'Most Recent',
  'common.sortName': 'Name (A-Z)',
  'common.sortCompletion': 'Completion',
  'common.allCategories': 'All Categories',
  'common.editCategories': 'Edit Categories',
  'common.creationInProgress': 'Creation in progress...',
  'common.calculationFailed': 'Calculation failed',

  // Loading status messages (V5 matching)
  'common.loadingStatus.analyzingProfile': 'Analyzing profile...',
  'common.loadingStatus.searchingSubsidies': 'Searching for subsidies...',
  'common.loadingStatus.checkingEligibility': 'Checking eligibility...',
  'common.loadingStatus.evaluatingMatches': 'Evaluating matches...',
  'common.loadingStatus.aiAnalysis': 'AI analysis in progress...',
  'common.loadingStatus.identifyingOpportunities': 'Identifying opportunities...',
  'common.loadingStatus.calculatingScores': 'Calculating scores...',
  'common.loadingStatus.selectingBestSubsidies': 'Selecting best subsidies...',
  'common.loadingStatus.comparingWithProfile': 'Comparing with profile...',
  'common.loadingStatus.analyzingCriteria': 'Analyzing criteria...',

  // Profile Dialog
  'common.profilesAvailable': '{count} profile available',
  'common.profilesAvailable_plural': '{count} profiles available',
  'common.profilesSuspended': '{count} profile suspended',
  'common.profilesSuspended_plural': '{count} profiles suspended',
  'common.noProfilesYet': 'No profiles created yet',
  'common.noSuspendedProfiles': 'No suspended profiles',
  'common.noProfileFound': 'No profile found',
  'common.noProfiles': 'No profiles',
  'common.tryAnotherSearch': 'Try another search',
  'common.createFirstProfile': 'Create your first profile to get started',
  'common.loadingMoreProfiles': 'Loading more profiles...',
  'common.loadingMoreSubsidies': 'Loading more subsidies...',
  'common.scrollToLoadMore': 'Scroll to load more subsidies',
  'common.noProfilesInCategory': 'No profiles in {category}',
  'common.noCategoryAssigned': 'No clients have been assigned to this category yet',
  'common.createYourFirstProfile': 'Create your first profile',
  'common.firstProfileDescription': 'Create your first client profile to start discovering suitable subsidies',

  // Archived Clients
  'common.loadingArchivedProfiles': 'Loading archived profiles...',
  'common.archivedClients': 'Archived clients',
  'common.clientArchived': '{count} archived client',
  'common.clientArchived_plural': '{count} archived clients',
  'common.refresh': 'Refresh',
  'common.archivedClientsInfo': 'Archived clients do not count towards your billing. You can reactivate them at any time.',
  'common.noResults': 'No results',
  'common.noArchivedClients': 'No archived clients',
  'common.archivedClientsWillAppearHere': 'Archived clients will appear here',
  'common.client': 'Client',
  'common.type': 'Type',
  'common.reason': 'Reason',
  'common.archived': 'Archived',
  'common.actions': 'Actions',
  'common.profileComplete': 'Profile {percent}% complete',
  'common.notSpecified': 'Not specified',
  'common.showing': 'Showing {filtered} of {total} client',
  'common.showing_plural': 'Showing {filtered} of {total} clients',
  'common.reactivateTip': '💡 Tip: Reactivate a client to have them count towards your billing again',
  'common.selected': 'Selected',

  // Applicant Type Descriptions
  'common.businessDescription': 'Companies, startups, SMEs, large enterprises',
  'common.nonprofitDescription': 'Public structures, local authorities and associations',
  'common.municipalityDescription': 'Local authorities and public interest projects',
  'common.individualDescription': 'Personal funding, freelancers, individual entrepreneurs',
  'common.creationTitle': 'Creation & Takeover',
  'common.creationDescription': 'Business creation or takeover projects',

  // Applicant Type Examples
  'common.innovationGrants': 'Innovation grants',
  'common.exportAid': 'Export aid',
  'common.rdFunding': 'R&D funding',
  'common.digitalTransformation': 'Digital transformation',
  'common.socialPrograms': 'Social programs',
  'common.communityProjects': 'Community projects',
  'common.culturalInitiatives': 'Cultural initiatives',
  'common.environmentalActions': 'Environmental actions',
  'common.infrastructure': 'Infrastructure',
  'common.urbanDevelopment': 'Urban development',
  'common.publicServices': 'Public services',
  'common.smartCityProjects': 'Smart city projects',
  'common.personalGrants': 'Personal grants',
  'common.trainingAid': 'Training aid',
  'common.housingAid': 'Housing aid',
  'common.trainingPrograms': 'Training programs',
  'common.creationAid': 'Creation aid',
  'common.startupSupport': 'Startup support',
  'common.launchFunding': 'Launch funding',
  'common.incubation': 'Incubation',

  // Workspace
  'workspace.selectSubsidiesToTransmit': 'Select funding to transmit',
  'workspace.generateDocument': 'Generate document',

  // AI Strategic Report
  'common.matches': 'matches',
  'common.generating': 'Generating...',
  'strategicReport.title': 'AI Strategic Report',
  'strategicReport.description': 'Get a personalized analysis of your best funding options, optimal combinations and timing advice.',
  'strategicReport.generate': 'Generate',
  'strategicReport.notEnoughMatches': 'Complete your profile to get at least 3 matches and access a personalized strategic report.',
  'strategicReport.error': 'Error generating report',
  'strategicReport.potentialFunding': 'Potential funding',
  'strategicReport.topRecommendations': 'Top recommendations',
  'strategicReport.combinationStrategies': 'Combination strategies',
  'strategicReport.urgentDeadlines': 'Urgent deadlines',
  'strategicReport.nextSteps': 'Next steps',
  'strategicReport.confidence': 'Confidence level',

  // Deadline Explanation
  'deadline.explainButton': 'Understand',
  'deadline.whyImportant': 'Why important?',
  'deadline.modalTitle': 'Deadline Analysis',
  'deadline.dueDate': 'Due date',
  'deadline.analyzing': 'Analyzing...',
  'deadline.error': 'Error during analysis',
  'deadline.urgencyLevel': 'Urgency level',
  'deadline.daysRemaining': 'days remaining',
  'deadline.strategicContext': 'Strategic context',
  'deadline.bestTime': 'Best time to apply',
  'deadline.actionItems': 'Recommended actions',
  'deadline.urgency.critical': 'Critical - Immediate action required',
  'deadline.urgency.high': 'High - Act quickly',
  'deadline.urgency.medium': 'Medium - Plan soon',
  'deadline.urgency.low': 'Low - Time available',

  // Eligibility Q&A
  'eligibility.button': 'Questions?',
  'eligibility.askQuestion': 'Ask a question',
  'eligibility.cardTitle': 'Eligibility questions?',
  'eligibility.cardDesc': 'Ask questions about this subsidy and get personalized answers',
  'eligibility.modalTitle': 'Eligibility Questions',
  'eligibility.suggestedQuestions': 'Suggested questions',
  'eligibility.inputPlaceholder': 'Ask your question...',
  'eligibility.analyzing': 'Analyzing...',
  'eligibility.error': 'Error during analysis',
  'eligibility.result.eligible': 'Likely eligible',
  'eligibility.result.notEligible': 'Likely not eligible',
  'eligibility.result.uncertain': 'Uncertain - more info needed',
  'eligibility.missingInfo': 'Missing information:',
  'eligibility.suggestions': 'Tips:',
  'eligibility.suggested.size': 'Is my 5-employee company eligible?',
  'eligibility.suggested.sector': 'Is this subsidy available for tech startups?',
  'eligibility.suggested.cumul': 'Can I combine this with other subsidies?',
  'eligibility.suggested.timing': 'Do I need to have already started my project?',

  // Saved Searches
  'savedSearches.saveDialogTitle': 'Save search',
  'savedSearches.saveDialogDescription': 'Give this search a name to find it easily later.',
  'savedSearches.nameLabel': 'Name',
  'savedSearches.defaultName': 'My search',
  'savedSearches.query': 'Search',
  'savedSearches.filters': 'Filters',
  'savedSearches.activeFilters': 'active filter(s)',
  'savedSearches.noFilters': 'No active filters or search',
  'savedSearches.errorNameRequired': 'Please enter a name',
  'savedSearches.errorNameTooLong': 'Name cannot exceed 100 characters',
  'savedSearches.saveSuccess': 'Search saved',
  'savedSearches.saveError': 'Error saving search',
} as const;
